import { render, staticRenderFns } from "./ScreenshotEditor.vue?vue&type=template&id=1c514b68&scoped=true&"
import script from "./ScreenshotEditor.vue?vue&type=script&lang=js&"
export * from "./ScreenshotEditor.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotEditor.vue?vue&type=style&index=0&id=1c514b68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c514b68",
  null
  
)

export default component.exports